/**
 * Converts [row, column] coordinates to linear index
 *
 * For a grid of given size, translates row and column position
 * to its corresponding flat array index.
 *
 * @param {number} r - Row position (0-indexed)
 * @param {number} c - Column position (0-indexed)
 * @param {number} size - Board dimension (e.g., 3 for 3x3)
 * @returns {number} Linear index in the board array
 *
 * @example
 * // For a 3x3 board:
 * // [0][1][2]
 * // [3][4][5]
 * // [6][7][8]
 * rcToIndex(0, 0, 3)  // 0 (top-left)
 * rcToIndex(1, 1, 3)  // 4 (center)
 * rcToIndex(2, 2, 3)  // 8 (bottom-right)
 * rcToIndex(1, 2, 3)  // 5 (middle row, right column)
 */
export function rcToIndex (r, c, size) {
  return r * size + c
}
